import { render, staticRenderFns } from "./CouponTManage.vue?vue&type=template&id=08974752&"
import script from "./CouponTManage.vue?vue&type=script&lang=js&"
export * from "./CouponTManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports